import './ResourceTabs.scss';
import { Icon } from '@gplibraries/react/components';
import { iconMap } from '@gplibraries/react/config';

export default function ResourceTabsBar(props) {

  const { categories, searchQuery, activeTab, setActiveTab } = props;

  return (
    <div className="flex-row resource-tab-bar">
      <div className="flex-row stretch left resource-tab-wrapper">

        {/*Only show search tab if there is a search query*/}
        {searchQuery.length > 0 && (
          <button
            className={`flex-row icon-button resource-tab ${activeTab === 'search' ? 'active' : ''}`}
            onClick={() => setActiveTab('search')}
          >
            <Icon glyph={'search'}/>
            <span className={'mobile-only'}>search for &quot;{searchQuery}&quot;</span>
          </button>
        )}

        {categories
          .sort((a, b) => a.weight - b.weight)
          .map(category =>
            <button
              key={category.id}
              className={`resource-tab flex-row ${activeTab === category.id ? 'active' : ''}`}
              onClick={() => setActiveTab(category.id)}
            >
              <Icon
                glyph={iconMap.categories[category.id]?.glyph}
                src={iconMap.categories[category.id]?.src}
              />
              {category.name}
            </button>
          )}

      </div>
    </div>
  );
}